<template>
  <div class="relative bg-white m-3 rounded-md">
    <div class="border-b-0.5 flex justify-between items-center p-3">
      <p class="text-sm font-semibold">SMS Tempate</p>
      <button @click="showCreateSmsTemplate = true" class="bg-primary text-white  px-3  text-sm py-1  rounded-md my-1">
        Create templates
      </button>
    </div>
    <transition name="fade">
      <div v-if="showSmsCreateSuccess" class="p-1 text-center text-sm w-full bg-green-200">
        {{ create_success }}
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showSmsSaveError" class="p-1 text-center text-sm w-full bg-yellow-200">
        {{ saveError }}
      </div>
    </transition>
    <transition name="fade">
      <div v-if="get_error" class="p-1 text-center text-sm w-full bg-yellow-200">
        {{ get_error }}
      </div>
    </transition>
    <div v-if="loading" class="absolute inset-0 bg-white z-50 rounded-md">
      <loader class="absolute center-h-v" />
    </div>
    <div v-if="innerLoader" class="absolute inset-0 bg-white z-50 rounded-md">
      <loader class="absolute inset-x-0 inset-y-10" />
    </div>
    <div>
      <div class="flex flex-wrap justify-between gap-x-3 bg-gray-100">
        <div class="py-2 bg-gray-100 text-sm flex gap-5 items-center">
          <p class="p-3">Choose template to edit</p>
          <select ref="printerSelect" v-model="selectedTemplateId" @change="onChange()"
            class="text-sm bg-transparent border-1.5 p-2 rounded-md">
            <option :value="template.Id" v-for="(template, index) in smsTemplatesList" :key="index">
              {{ template.TemplateName }}
            </option>
          </select>
        </div>

        <div v-if="selectedTemplate != null" class="flex justify-end my-4 ml-3 pr-3">
          <button @click="deleteTemplate(selectedTemplate[0].Id)"
            class="border border-0.5 border-red-500 text-red-500 rounded-full px-3 py-1 text-sm">
            Delete this templates
          </button>
        </div>
      </div>
      <p v-if="selectedTemplate == null" class="p-3 text-center">
        No template selected
      </p>
      <div v-if="selectedTemplate != null" class="grid grid-cols-1 sm:grid-cols-3">
        <div class="col-span-1 p-5">
          <p class="pb-2 text-sm text-center">SMS preview</p>
          <p id="sms-preview" class="preview text-xs ml-4">
            {{ selectedTemplate[0].TemplateBody }}
          </p>
        </div>
        <div class="col-span-2 p-5">
          <p class="pb-2 text-sm">Edit SMS template below</p>
          <textarea id="editable" ref="editable" v-model="selectedTemplate[0].TemplateBody" rows="5"
            placeholder="Enter SMS  template here" class="w-full p-2 rounded-md bg-gray-200 text-sm"></textarea>
          <div class="flex justify-end my-4">
            <button @click="saveChanges" class="bg-green-400 rounded hover:shadow-md text-white p-1.5 text-xs">
              Save changes
            </button>
          </div>
          <div class="flex flex-wrap gap-3">
            <span v-for="variable in smsVariables" :key="variable.Id"
              class="bg-gray-200 px-2 py-1 hover:bg-buttonColor hover:text-white rounded-full text-xs cursor-pointer">{{
                variable.VariableKey }}</span>
          </div>
        </div>
      </div>
    </div>
    <CreateSmsTemplate :showCreateSmsTemplate="showCreateSmsTemplate" @close="close"
      @closeOnSuccess="handleCloseOnSuccess"></CreateSmsTemplate>
  </div>
</template>

<script>
var _ = require("lodash");
import axios from "axios";
import { mapGetters } from "vuex";
//var qs = require("qs");
import Loader from "@/components/loader/loader.vue";
import CreateSmsTemplate from "@/components/AdminSetups/sms/createSmsTemplate.vue";
export default {
  name: "SMSTemplate",
  components: { Loader, CreateSmsTemplate },
  props: ["smsTemplatesList", "loading", "loadingTemplates", "smsVariables"],
  data() {
    return {
      selectedTemplate: null,
      selectedTemplateId: null,
      showSmsCreateSuccess: false,
      create_success: null,
      innerLoader: false,
      showSmsSaveError: null,
      saveError: null,
      get_error: null,
      templateText: "",
      textCopied: false,
      templateId: null,
      success: false,
      error: false,
      showCreateSmsTemplate: false,
      variables: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },

  methods: {
    onChange() {
      this.selectedTemplate = _.filter(this.smsTemplatesList, [
        "Id",
        this.selectedTemplateId,
      ]);
    },
    close() {
      this.showCreateSmsTemplate = false;
    },
    saveChanges() {
      this.innerLoader = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      var data = {
        TemplateId: this.selectedTemplate[0].Id,
        TemplateName: this.selectedTemplate[0].TemplateName,
        TemplateBody: this.selectedTemplate[0].TemplateBody,
      };
      axios
        .put(
          `setup/sms/template/${this.$ApiVersion}/edit`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.innerLoader = false;
            if (response.data.StatusCode == 200) {
              //this.$emit("closeOnSuccess", response.data.StatusMessage);
              this.handleCloseOnSuccess(response.data.StatusMessage);
            } else {
              this.handleErrorOnSaveChanges(response.data.StatusMessage);
            }
          },
          (error) => {
            this.innerLoader = false;
            this.handleErrorOnSaveChanges(error.message);
          }
        );
    },
    deleteTemplate(id) {
      this.innerLoader = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `setup/sms/template/${id}/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.innerLoader = false;
            if (response.data.StatusCode == 200) {
              this.handleCloseOnSuccess(response.data.StatusMessage);
              this.selectedTemplate = null;
            } else {
              this.handleErrorOnSaveChanges(response.data.StatusMessage);
            }
          },
          (error) => {
            this.innerLoader = false;
            this.handleErrorOnSaveChanges(error.message);
          }
        );
    },
    handleErrorOnSaveChanges(message) {
      this.saveError = message;
      this.showSmsSaveError = true;
      setTimeout(() => {
        this.showSmsSaveError = false;
      }, 3000);
    },
    handleCloseOnSuccess(message) {
      this.create_success = message;
      this.showCreateSmsTemplate = false;
      this.showSmsCreateSuccess = true;
      setTimeout(() => {
        this.showSmsCreateSuccess = false;
      }, 3000);
      this.$emit("updateSmsTemplatesList");
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.preview {
  background: #e5e5ea;
  color: black;
  align-self: flex-start;
}

.preview:before {
  left: -7px;
  width: 20px;
  background-color: #e5e5ea;
  border-bottom-right-radius: 16px 14px;
}

.preview:after {
  left: -26px;
  width: 26px;
  background-color: white;
  border-bottom-right-radius: 10px;
}

#sms-preview {
  max-width: 255px;
  word-wrap: break-word;
  margin-bottom: 12px;
  line-height: 24px;
  position: relative;
  padding: 20px 20px;
  border-radius: 25px;
}

#sms-preview:before,
#sms-preview:after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 25px;
}
</style>
